import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../../../auth/core/auth.service';

/**
 * Guards /admin. Applied on the parent shell route, so it runs before the shell's own
 * ngOnInit - it loads currentUser itself rather than relying on the shell for that.
 */
export const adminGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  }

  return authService.loadCurrentUser().pipe(
    map((user) => (user.role === 'ADMIN' ? true : router.createUrlTree(['/']))),
    catchError(() => of(router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }))),
  );
};
